var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.show.full)?_c('span',{on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.show.full = true}}},[_vm._v(_vm._s(_vm.short[0])),_c('a',[_vm._v("....")]),_vm._v(_vm._s(_vm.short[1]))]):_c('span',[_vm._v(_vm._s(_vm.str))])
}
var staticRenderFns = []

export { render, staticRenderFns }